import * as React from 'react';

const RefreshStockButton = (props) => {
  return (
    <>
      {props?.fetchInventoryFromServer ?
        <a onClick={() => { props.fetchInventoryFromServer(); }}
          style={{ cursor: 'pointer' }} id="listing" className="refresh-link">
          <i className="fa fa-refresh mx-2 grey-refresh" />
          <span className="thin text-none font-12"><b><i>{props.label}</i> </b></span>
        </a> :
        <a style={{ cursor: 'auto' }} className="refresh-link">
          <i className="fa fa-refresh mx-2 grey-refresh" />
          <span className="thin text-none font-12"><b><i>{props.label}</i></b></span>
        </a>
      }

    </>
  );
};

export default RefreshStockButton;